export default function minstache(str, ctx) {
  return str
    .split(/\{\{|\}\}/)
    .map((t, i) => (!(i % 2) ? t : ctx[t]))
    .join('');
}



// WEBPACK FOOTER //
// ./utils/minstache.js